import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDidMountEffect from "../../../../utils/useDidMountEffect";
import useCheckPermission from "../../../../utils/checkPermission";
import { createTransactionDriverStart, getTransactionDriversStart, updateTransactionDriverStart, deleteTransactionDataStart } from "../../../../store/redux-slices/transactionDriversSlice";
import { toast } from '../../../../components/Toast'

const useTransactionsDriver = () => {
  const { loading, transactionDrivers, deleteTransactionDriver } = useSelector(
    (state) => state.transactionDrivers
  );

  const agents = transactionDrivers?.data || [];
  const pagination = transactionDrivers?.pagination || {};

  const isInitialRender = useDidMountEffect();
  const [limit, setLimit] = useState(15);
  const [page, setPage] = useState(1);
  const [type, setType] = useState("");
  const [data, setData] = useState({});
  const [show, setShow] = useState(false);
  const [validation, setValidation] = useState({});
  const [deleteConfirmation, setDeleteConfirmation] = useState({
    id: "",
    name: "",
    open: false
  })
  const { isHidden } = useCheckPermission();

  const totalPages = pagination?.totalPages;
  const totalCount = pagination?.totalItems
    ;
  const dispatch = useDispatch();

  useEffect(() => {
    setPage(1);
    dispatch(
      getTransactionDriversStart({
        limit: limit,
        pageNo: page,
      })
    );
  }, [limit]);

  useEffect(() => {
    !isInitialRender &&
      dispatch(
        getTransactionDriversStart({
          limit: limit,
          pageNo: page,
        })
      );
  }, [page]);

  const handleCreateEdit = (type, data) => {
    setType(type);
    setData(data);
    setShow(true);
  };

  const handleToggleStatus = (transactionAgentId, newStatus) => {
    const currentDriver = agents.find(agent => agent.transactionAgentId === transactionAgentId);

    if (currentDriver) {
      dispatch(updateTransactionDriverStart({
        data: {
          transactionAgentId,
          agentName: currentDriver.agentName,
          agentNumber: currentDriver.agentNumber,
          agentEmail: currentDriver.agentEmail,
          description: currentDriver.description,
          status: newStatus,
        },
        optimisticUpdate: true,
        previousStatus: currentDriver.status,
        onSuccess: () => {
          toast("Status updated successfully", "success");
          // console.log("Status updated successfully");
        },
      }));
    } else {
      console.error('Driver not found with ID:', transactionAgentId);
    }
  };

  const createUpdate = (data) => {
    const actionCreator =
      type === "Create"
        ? createTransactionDriverStart({
          data: {
            agentName: data?.agentName,
            agentNumber: data?.agentNumber,
            agentEmail: data?.agentEmail,
            description: data?.description,
            status: data?.status,
          },
          onSuccess: () => {
            setShow(false);
            toast("Transaction driver Created successfully", "success");
            dispatch(
              getTransactionDriversStart({
                limit: limit,
                pageNo: page,
              })
            );
          },
        })
        : updateTransactionDriverStart({
          data: {
            transactionAgentId: data?.transactionAgentId,
            agentName: data?.agentName,
            agentNumber: data?.agentNumber,
            agentEmail: data?.agentEmail,
            description: data?.description,
            status: data?.status,
          },
          optimisticUpdate: false,
          onSuccess: () => {
            setShow(false);


            toast("Transaction driver updated successfully", "success");

            dispatch(
              getTransactionDriversStart({
                limit: limit,
                pageNo: page,
              })
            );
          },
        });

    dispatch(actionCreator);
  };

  const handleDelete = (data) => {
    setDeleteConfirmation((prev) => ({
      ...prev,

      id: data?.transactionAgentId
      ,
      name: data?.agentName || '',
      open: true
    }));

  }

  const onhandleDelete = () => {
    dispatch(deleteTransactionDataStart({
      data: {
        transactionAgentId: deleteConfirmation?.id
      },

      onSuccess: () => {
        toast("Driver deleted successfully", "success");
        setDeleteConfirmation((prev) => ({
          ...prev,

          id: ""
          ,
          name: '',
          open: false
        }));
        dispatch(
          getTransactionDriversStart({
            limit: limit,
            pageNo: page,
          })
        );
      },
    })
    )
  }

  return {
    loading,
    agents,
    handleCreateEdit,
    handleToggleStatus,
    type,
    data,
    setShow,
    show,
    createUpdate,
    dispatch,
    isHidden,
    page,
    limit,
    setPage,
    setLimit,
    totalPages,
    validation,
    setValidation,
    handleDelete,
    deleteConfirmation,
    setDeleteConfirmation,
    onhandleDelete,
    totalCount
  };
};

export default useTransactionsDriver;
